import { FaWhatsapp } from 'react-icons/fa'

const WhatsAppButton = () => {
  const phoneNumber = '923098391932'

  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}`, '_blank', 'noopener,noreferrer')
  }

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-20 right-5 z-[75] inline-flex h-14 w-14 items-center justify-center rounded-full border border-green-300/50 bg-gradient-to-br from-green-500 to-green-600 text-white shadow-2xl hover:scale-105"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp className="h-8 w-8" />
    </button>
  )
}

export default WhatsAppButton
